import { locale } from "../../../utilities/locale/locale";
import StorePageIcon from "../StorePageIcon";
import localeText from "../../../locale";
import { Divider } from "primereact/divider";
import { useState } from "react";
import { Dialog } from "primereact/dialog";

const UserStoreHeader = ({ storeInfo }) => {
  const [showModal, setShowModal] = useState(false);

  const getCategoriesNames = (category) => {
    const categoriesNames = {
      pt: category.descriptionPortuguese,
      it: category.descriptionItalian,
      es: category.descriptionSpanish,
      en: category.descriptionEnglish,
    };
    return categoriesNames[locale];
  };

  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <div className="grid grid-nogutter w-full gap-5 col-12 md:col">
      <div className="col-12">
        <div className={`flex flex-column ${storeInfo?.shopConfiguration?.video ? 'align-items-center' : 'align-items-start'}`}>
          <div className="font-bold text-lg" style={{ color: "#344563" }}>
            {storeInfo.shopConfiguration.title}
          </div>

          <div className="flex align-items-center gap-3 mt-2">
            <StorePageIcon />
            <span className="text-sm" style={{ color: "#344563" }}>
              {storeInfo?.shopConfiguration?.user?.address},{" "}
              {storeInfo?.shopConfiguration?.user?.number} -{" "}
              {storeInfo?.shopConfiguration?.user?.city} (
              {storeInfo?.shopConfiguration?.user?.state})
            </span>
          </div>
          <div className="flex gap-3 mt-3">
            {storeInfo?.shopConfiguration?.instagram && (
              <a
                href={`https://instagram.com/${storeInfo.shopConfiguration.instagram}`}
                target="_blank"
                rel="noreferrer"
                style={{ color: "#091E42" }}
              >
                <i className="pi pi-instagram text-xl"></i>
              </a>
            )}
            {storeInfo?.shopConfiguration?.twitter && (
              <a
                href={`https://twitter.com/${storeInfo.shopConfiguration.twitter}`}
                target="_blank"
                rel="noreferrer"
                style={{ color: "#091E42" }}
              >
                <i className="pi pi-twitter text-xl"></i>
              </a>
            )}
            {storeInfo?.shopConfiguration?.facebook && (
              <a
                href={`https://facebook.com/${storeInfo.shopConfiguration.facebook}`}
                target="_blank"
                rel="noreferrer"
                style={{ color: "#091E42" }}
              >
                <i className="pi pi-facebook text-xl"></i>
              </a>
            )}
            {storeInfo?.shopConfiguration?.tiktok && (
              <a
                href={`https://tiktok.com/@${storeInfo.shopConfiguration.tiktok}`}
                target="_blank"
                rel="noreferrer"
                style={{ color: "#091E42" }}
              >
                <i className="pi pi-tiktok text-xl"></i>
              </a>
            )}
            {storeInfo?.shopConfiguration?.youtube && (
              <a
                href={`https://youtube.com/${storeInfo.shopConfiguration.youtube}`}
                target="_blank"
                rel="noreferrer"
                style={{ color: "#091E42" }}
              >
                <i className="pi pi-youtube text-xl"></i>
              </a>
            )}
            {storeInfo?.shopConfiguration?.linkedin && (
              <a
                href={`https://linkedin.com/${storeInfo.shopConfiguration.linkedin}`}
                target="_blank"
                rel="noreferrer"
                style={{ color: "#091E42" }}
              >
                <i className="pi pi-linkedin text-xl"></i>
              </a>
            )}
            {storeInfo?.shopConfiguration?.website && (
              <a
                href={storeInfo.shopConfiguration.website}
                target="_blank"
                rel="noreferrer"
                style={{ color: "#091E42" }}
              >
                <i className="pi pi-globe text-xl"></i>
              </a>
            )}
          </div>
        </div>
      </div>
      <div className="col flex flex-column gap-3">
        <div>
          <div className="text-sm" style={{ color: "#7A869A" }}>
            {localeText("category")}
          </div>
          <div className="flex gap-3 mt-2">
            {storeInfo?.shopConfiguration?.categories?.map((category) => (
              <div
                className="text-sm underline font-semibold"
                style={{ color: "#535862" }}
                key={category.id}
              >
                {getCategoriesNames(category)}
              </div>
            ))}
          </div>
        </div>
        <div>
          <div className="text-sm" style={{ color: "#7A869A" }}>
            {localeText("description")}
          </div>
          <div className="flex flex-wrap align-items-baseline gap-2">
            <div
              className="truncate-3-lines mt-2 text-sm"
              style={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                WebkitLineClamp: 3,
                WebkitBoxOrient: "vertical",
                color: "#344563",
              }}
              dangerouslySetInnerHTML={{ __html: storeInfo?.shopConfiguration?.description }}
            ></div>
            <span
              className="text-sm underline font-semibold cursor-pointer"
              style={{ color: "#433AC8" }}
              onClick={openModal}
            >
              {localeText("readMore")}
            </span>
          </div>
        </div>
      </div>
      <Dialog
        visible={showModal}
        style={{ width: "50rem", maxWidth: "95vw" }}
        onHide={closeModal}
        header={localeText("description")}
        modal={true}
        closable={true}
      >
        <div className="font-bold text-lg mb-3" style={{ color: "#344563" }}>
          {storeInfo.shopConfiguration.title}
        </div>
        {storeInfo.shopConfiguration.video && (
          <div className="mb-4">
            <video
              controls
              className="border-round-lg w-full"
              style={{
                maxHeight: "400px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              }}
              src={storeInfo.shopConfiguration.video}
            >
              {localeText("videoNotSupported")}
            </video>
          </div>
        )}
        <div
          className="text-sm mb-3"
          style={{ color: "#344563" }}
          dangerouslySetInnerHTML={{ __html: storeInfo?.shopConfiguration?.description }}
        ></div>
      </Dialog>
    </div>
  );
};

export default UserStoreHeader;
